import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BaseApiTemplateService } from '../../shared';
import { Core2Config } from '../../shared';
import { SvcIssueWorklogContainerModel } from '../../../../../../models/aggregates/erp/rma/index';

@Injectable({
  providedIn: 'root'
})
export class ServiceIssueWorklogService extends BaseApiTemplateService<SvcIssueWorklogContainerModel> {
  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + 'svc/issue-worklogs/backoffice-ep';
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + 'svc/issue-worklogs/backoffice-ep';
    this.httpClient = http;
  }
}